
export const BACKEND_URL = (process.env.NODE_ENV === 'development') ? process.env.REACT_APP_API_URL : ''

export const post = (url, body, signal) => {
    return fetch(BACKEND_URL + url, {
        method: 'POST',
        signal,
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
        credentials: 'include',
    })
        .then((response) => {
            const status = response.status
            if (status < 200 || status > 300) {
                return response.json()
                    .then(body => {
                        if (body && body.exception === 'NotAuthenticatedException') {
                            window.location.reload()
                        }
                        return Promise.reject(body)
                    })
            }
            return response.json()
        })
}


export const get = (url) => {
    return fetch(BACKEND_URL + url, {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        credentials: 'include',
    })
        .then((response) => {
            const status = response.status
            if (status < 200 || status > 300) {
                return response.json()
                    .then(body => {
                        if (body && body.exception === 'NotAuthenticatedException') {
                            window.location.reload()
                        }
                        return Promise.reject(body)
                    })
            }
            return response.json()
        })
}



// WEBPACK FOOTER //
// ./src/util/api.js